import { useMutation } from '@tanstack/react-query';
import { patchEventsId } from '../api/generated/arrayscapeGamingDashboardAPI';
import type { JsonPatchOperation } from '../api/generated/model';

export const useUpdateEvent = () => {
  return useMutation({
    mutationFn: async ({ id, patch }: { id: string; patch: JsonPatchOperation[] }) => {
      return await patchEventsId(id, patch);
    },
    // Note: No automatic query invalidation - local state is updated immediately
    // in the handleSaveEvent function, and highlighting tracks modifications
  });
};
